import React from 'react';

import { useDeleteInfluencerChannel } from 'scenes/Influencers/InfluencersChannels/data';

import Permissions from '@gogame/permissions';
import {
  Action,
  Actions as UIActions,
  DeleteIcon,
  EditIcon,
} from '@gogame/components';

const InfluencerChannelsActions = ({ actions, data, onEdit, onDelete }) => {
  const [deleteInfluencerCampaign] = useDeleteInfluencerChannel();

  const handleDelete = async () => {
    await deleteInfluencerCampaign({ id: data.id, name: data.name });
    onDelete?.();
  };

  const handleEdit = () => onEdit(data);

  return (
    <Permissions actions={actions}>
      {({ isActionAllowed }) => (
        <UIActions>
          <Action
            id={'edit'}
            icon={<EditIcon />}
            label={'Edit'}
            disabled={!isActionAllowed('Edit')}
            onClick={handleEdit}
          />
          <Action
            id={'delete'}
            icon={<DeleteIcon />}
            label={'Delete'}
            disabled={!isActionAllowed('Delete')}
            onClick={handleDelete}
          />
        </UIActions>
      )}
    </Permissions>
  );
};

export default InfluencerChannelsActions;
